export function appendQueryParameter(path: string, key: string, value: string): string {
  const paramString = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  if (path.indexOf("?") > -1) {
    return path + "&" + paramString;
  }
  return path + "?" + paramString;
}
